<template>
  <div class="pay-main-container wrapper">
    <h3 class="paypage-title">Course in this order</h3>
    <div  class="papage-coursebox">
      <img :src="courseData.cover" alt="">
      <div class="papage-coursebox-infos">
        <h4 class="papage-coursebox-info-title">{{ courseData.title }}</h4>
        <p class="papage-coursebox-info-desp">{{ courseData.short_desp }}</p>
        <div v-if="courseData.chapter" class="papage-coursebox-info-lessons">{{ courseData.chapter.length + (courseData.chapter.length > 1 ? ' Lessons' : ' Lesson') }}</div>
        <div class="papage-coursebox-info-div"></div>
        <div v-if="orderData.chapters" class="papage-coursebox-info-orderinfo">
          <span class="lesson-info">{{ orderData.chapters.length + (orderData.chapters.length > 1 ? ' lessons' : ' lesson') }} included in this order</span>
          <span class="price-info">Price: ${{ Number((orderData.price / 100).toFixed(2)) }}</span>
        </div>
      </div>
    </div>
    <h3 class="paypage-title">Select a payment method</h3>
    <div class="papage-payment-methods">
      <h2>
        Users from China need to pay in CNY (1$ USD ≈ {{ orderData.exchange_rate }}￥ CNY)
      </h2>
      <ct-radio
        class="papage-payment-methods-item"
        horizon
        :label="payMethods.wx"
        v-model="pay_channel">
        <div class="papage-payment-methods-item-text" slot="labelText">
          <img src="@/assets/img/comet/live/wechat@2x.png" alt="">
          Pay with Wechat Pay</div></ct-radio>
      <ct-radio
        class="papage-payment-methods-item"
        horizon
        v-if="!ua.isWechat"
        :label="payMethods.ali"
        v-model="pay_channel">
        <div class="papage-payment-methods-item-text" slot="labelText">
          <img src="@/assets/img/comet/live/Alipay@2x.png" alt="">
          Pay with Alipay</div></ct-radio>
    </div>
    <div class="paypage-confirm-box">
      ${{ Number((orderData.price / 100).toFixed(2)) }}
      <ct-button
        :isLoading="btnLoading"
        :disabled="btnDisable"
        @click="confirm"
        class="confirm-btn"
        size="large"
        type="primary">{{ buttonText }}</ct-button>
    </div>
    <div class="paypage-countdown-box">
      Please checkout in 30 min, and <span>{{ time_countdown }}</span> remains
    </div>
    <ct-modal
      id="wechat-qrcode-modal"
      title="Scan the QR code below using the Wechat App"
      v-if="qrcodeVisible"
      width="540px"
      @closed="closedQrCode">
      <div slot="body">
        <p class="qr-code-countdown-text">
          Please checkout in 30 min, and  <span class="qr-code-countdown-num">{{ time_countdown }}</span> remains
        </p>
        <p class="qr-code-countdown-img">
          <img :src="qrcodeImg" alt="">
        </p>
        <p class="qr-code-loading-box">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none"/>
          </svg>
          Verifying payment result…
        </p>
      </div>
      <div slot="footer" style="text-align: center;">
        <ct-button type="secondary" @click.prevent="closedQrCode">cancel</ct-button>
      </div>
    </ct-modal>
    <ct-modal
      id="interval-modal"
      v-if="intervalmodalvisible"
      width="400px"
      title=""
      @closed="closedIntervalModal">
      <div slot="body">
        <p class="qr-code-loading-box">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none"/>
          </svg>
          Verifying payment result…
        </p>
      </div>
      <div slot="footer" style="text-align: center;">
        <ct-button type="secondary" @click.prevent="closedIntervalModal">cancel</ct-button>
      </div>
    </ct-modal>
    <ct-modal
      id="checkout-faild-modal"
      title="Checkout Failed"
      v-if="checkoutFaildModal"
      width="480px"
      @closed="checkoutFaildModal=false">
      <div slot="body">
        <p class="checkout-faild-text">
          Sorry, checkout failed. Please change the payment method and try again later. If you want to cancel this order, visit the “My Orders” page.
        </p>
      </div>
      <div slot="footer">
        <ct-button type="text_secondary_light" @click.prevent="$router.push({ name: 'userOrders' })">See my orders</ct-button>
        <ct-button type="primary" @click.prevent="checkoutFaildModal=false">Got it</ct-button>
      </div>
    </ct-modal>
  </div>
</template>

<script>
import api, { chargeOrder } from '../../api'
// import pingpp from 'pingpp-js'
// import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import { vueAppDomin, vueAppPassportDomin } from '@ca/constants/variables'
import qrcode from 'qrcode'
import { orderState, PayMethods } from '@ca/constants'
export default {
  name: 'PayPage',
  data () {
    return {
      courseData: {},
      orderData: {},
      pay_channel: '',
      time_countdown: '00:00',
      has_expired: true,
      timeid: undefined,
      buttonText: 'Checkout',
      btnLoading: false,
      forceDisable: false,
      qrcodeVisible: false,
      checkoutFaildModal: false,
      qrcodeImg: '',
      intervalmodalvisible: false,
      forceStopQueryOrder: false,
      intervalId: undefined
    }
  },
  methods: {
    goHome () {
      this.$toast({
        type: 'error',
        message: 'Oops, something went wrong, please try again later.'
      })
      this.$router.push({
        name: 'live'
      })
    },
    cannotPay () {
      this.intervalmodalvisible = false
      this.$confirm({
        title: 'Invalid Order!',
        message: 'The order has become invalid. Please go back to restart the process.',
        confirmButtonText: 'Got it',
        handleAction: (val, res, rej) => {
          res()
          window.location.href = vueAppDomin + '/live/' + this.orderData.goods_id
        },
        closed: () => {
          window.location.href = vueAppDomin + '/live/' + this.orderData.goods_id
        }
      })
    },
    closedQrCode () {
      this.forceStopQueryOrder = true
      this.qrcodeVisible = false
    },
    checkoutFaild () {
      this.forceStopQueryOrder = true
      this.qrcodeVisible = false
      this.intervalmodalvisible = false
      this.checkoutFaildModal = true
    },
    queryInterval () {
      if (this.forceStopQueryOrder || this.has_expired) return
      api.queryOrder({
        params: {
          order_no: this.order_no,
          keep_alive: 1
        }
      }).then(res => {
        let data = res.data
        if (data.code === 1) {
          if (data.data.state === orderState['SUCCESS_PAY']) {
            this.qrcodeVisible = false
            this.intervalmodalvisible = false
            this.$toast({
              type: 'success',
              message: 'Checkout Success'
            })
            this.$router.push({
              name: 'checkoutSuccess',
              query: {
                order_no: this.order_no
              }
            })
          } else if (data.data.state !== orderState['WAIT_PAY']) {
            this.cannotPay()
          } else {
            this.intervalId = setTimeout(() => {
              this.queryInterval()
            }, 1000)
          }
        } else {
          this.checkoutFaild()
        }
      }, () => {
        this.checkoutFaild()
      })
    },
    closedIntervalModal () {
      this.forceStopQueryOrder = true
      this.intervalmodalvisible = false
    },
    confirm () {
      // 按钮状态
      if (this.btnDisable) return
      // 未登录
      if (!this.isAuthenticated) {
        window.location.href = vueAppPassportDomin + '/login?return_url=' + window.location.href
        return
      }
      api.queryOrder({
        params: {
          order_no: this.order_no,
          keep_alive: 0
        }
      }).then(res => {
        let data = res.data
        if (data.code === 1) {
          // 已支付
          if (data.data.state === orderState['SUCCESS_PAY']) {
            this.$router.push({
              name: 'checkoutSuccess',
              query: {
                order_no: this.order_no
              }
            })
          } else if (data.data.state !== orderState['WAIT_PAY']) {
            this.cannotPay()
          } else {
            this.pay()
          }
        } else {
          console.log(data.error)
          this.$toast('Oops, something went wrong ,please try again later')
        }
      }, err => {
        console.log(err)
        this.$toast('Oops, something went wrong ,please try again later')
      })
    },
    pay () {
      // 支付
      this.forceStopQueryOrder = false
      this.btnLoading = true
      if (this.pay_channel === PayMethods['PC_ALI'] || this.pay_channel === PayMethods['MOBILE_ALI']) {
        this.queryInterval()
        this.intervalmodalvisible = true
        window.open(vueAppDomin + `/charge/alipay_redirect/${this.pay_channel}/${this.order_no}`)
        this.btnLoading = false
      } else {
        chargeOrder({
          order_no: this.order_no,
          channel: this.pay_channel
        }).then(res => {
          if (res.data.code === 1) {
            this.queryInterval()
            this.btnLoading = false
            if (this.pay_channel === PayMethods['PC_WX']) {
              let option = {
                width: 156
              }
              qrcode.toDataURL(res.data.data.credential.wx_pub_qr, option, (err, url) => {
                if (err) throw err
                this.qrcodeImg = url
              })
              this.qrcodeVisible = true
            } else if (this.pay_channel === PayMethods['NATIVE_WX']) {
              api.getWxAuth({
                data: {
                  order_no: this.order_no
                }
              }).then(res => {
                let data = res.data
                if (data.code === 1) {
                  window.location.href = data.data.oauth_url
                } else {
                  this.forceStopQueryOrder = true
                  this.$toast({
                    type: 'error',
                    message: 'Oops, something went wrong, please try again later'
                  })
                }
              })
            }
          } else if (res.data.code === 90308) {
            this.cannotPay()
          } else {
            this.$toast({
              type: 'error',
              message: res.data
            })
          }
        }, err => {
          this.$toast({
            type: 'error',
            message: err
          })
        })
      }
    },
    startTime () {
      let begin = this.orderData.order_at * 1000
      let end = begin + (30 * 60 * 1000)
      if (new Date().getTime() > end) {
        this.has_expired = true
        this.buttonText = 'Time out'
        clearInterval(this.timeid)
      } else {
        this.has_expired = false
        this.timeid = setInterval(() => {
          let a = new Date().getTime()
          let b = new Date(end).getTime()
          if (a >= b) {
            clearInterval(this.timeid)
            this.has_expired = true
            this.buttonText = 'Time out'
            return
          }
          let m = parseInt((b - a) / 1000 / 60) + ''
          m = m.length < 2 ? '0' + m : m
          let s = parseInt(((b - a) / 1000) - m * 60) + ''
          s = s.length < 2 ? '0' + s : s
          this.time_countdown = m + ':' + s
        }, 1000)
      }
    }
  },
  mounted () {
    api.queryOrder({
      params: {
        order_no: this.order_no,
        keep_alive: 0
      }
    }).then(res => {
      let data = res.data
      if (data.code === 1) {
        this.orderData = data.data
        api.getLiveCourseDetail({
          params: {
            goods_id: data.data.goods_id
          }
        }).then(result => {
          let data = result.data
          if (data.code === 1) {
            data.data.cover = data.data.cover || this.defaultCover
            this.courseData = data.data
            this.pay_channel = this.payMethods.wx
            this.startTime()
          } else {
            this.goHome()
          }
        })
      } else {
        // if(data.code === 90305)      未查询到订单，可能是乱撞url撞到了别人的订单
        this.goHome()
      }
    })
  },
  destroyed () {
    this.qrcodeVisible = false
    this.intervalmodalvisible = false
    this.checkoutFaildModal = false
    this.forceStopQueryOrder = true
    clearInterval(this.timeid)
    clearInterval(this.intervalId)
  },
  computed: {
    ...mapState(['ua']),
    ...mapGetters(['isAuthenticated']),
    order_no () {
      return this.$route.params.order_no
    },
    btnDisable () {
      return this.btnLoading || this.has_expired || this.forceDisable || !this.pay_channel
    },
    payMethods () {
      return {
        wx: (this.ua.isWechat && this.ua.isMobile) ? PayMethods['NATIVE_WX'] : PayMethods['PC_WX'],
        ali: this.ua.isMobile ? PayMethods['MOBILE_ALI'] : PayMethods['PC_ALI']
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@mixin overflowTextStyle($lines) {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: $lines;
  line-clamp: $lines;
  -webkit-box-orient: vertical;
}
@-webkit-keyframes loading-rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg)
  }
}

@keyframes loading-rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg)
  }
}

@-webkit-keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px
  }
}

@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px
  }
}

  .pay-main-container {
    color: #1a3d5e;
    padding-bottom: 100px;
    .paypage-title {
      margin: 56px 0 24px;
      font-size:20px;
      font-weight:500;
      line-height:24px;
      padding-left: 17px;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: #37CAD7;
      }
    }
    .papage-coursebox {
      padding: 32px 24px 32px 16px;
      height: 232px;
      border-radius:2px;
      border:1px solid rgba(26,61,94,.1);
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      > img {
        width: 298px;
        margin-right: 24px;
      }
      .papage-coursebox-infos {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        overflow: hidden;
        .papage-coursebox-info-title {
          font-size:24px;
          font-weight:500;
          line-height:24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
        }
        .papage-coursebox-info-desp {
          font-size:14px;
          font-weight:400;
          color:rgba(54,85,114,1);
          line-height:22px;
          height: 44px;
          width: 100%;
          @include overflowTextStyle(2);
        }
        .papage-coursebox-info-lessons {
          background:rgba(239,244,250,1);
          border-radius:14px;
          font-size:12px;
          font-weight:400;
          line-height:12px;
          padding: 8px;
        }
        .papage-coursebox-info-div {
          align-self: stretch;
          border-top: 1px solid rgba(232,235,238,1);
        }
        .papage-coursebox-info-orderinfo {
          display: flex;
          align-self: stretch;
          justify-content: space-between;
          .lesson-info {
            font-size:14px;
            font-weight:400;
            color:rgba(54,85,114,.8);
          }
          .price-info {
            font-size:14px;
            font-weight:500;
          }
        }
      }
    }
    .papage-payment-methods {
      border-radius: 2px;
      padding: 12px 16px;
      border: 1px solid rgba(26, 61, 94, .1);
      height: 184px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: stretch;
      margin-bottom: 64px;
      h2 {
        font-size:14px;
        font-family:SFProText-Semibold,SFProText;
        font-weight:600;
        color:rgba(26,61,94,1);
        line-height:14px;
      }
      .papage-payment-methods-item {
        margin: 0;
        .papage-payment-methods-item-text {
          font-size:14px;
          font-weight:400;
          color:rgba(26,61,94,1);
          line-height:20px;
          img {
            width: 21px;
            vertical-align: middle;
            margin-left: 20px;
            margin-right: 4px;
            transform: translateY(-2px);
          }
        }
      }
    }
    .paypage-confirm-box {
      text-align: right;
      font-size:24px;
      font-weight:500;
      color:rgba(55,202,215,1);
      margin-bottom: 16px;
      .confirm-btn {
        margin-left: 32px;
      }
    }
    .paypage-countdown-box {
      font-size:16px;
      text-align: right;
      font-weight:400;
      color:rgba(72,100,126,1);
      line-height:19px;
      span {
        color: #F57373;
      }
    }
    #wechat-qrcode-modal {
      width: 100%;
      height: 100%;
      .qr-code-countdown-text {
        text-align: center;
        margin-bottom: 32px;
        .qr-code-countdown-num {
          color: #F57373;
        }
      }
      .qr-code-countdown-img {
        width: 160px;
        height: 160px;
        margin: 0 auto 16px;
        border:1px solid rgba(26,61,94,.1);
        text-align: center;
      }
      .qr-code-loading-box {
        text-align: center;
        line-height: 18px;
        color: #A3B1BF;
      }

    }
    #interval-modal {
      .qr-code-loading-box {
        font-size:20px;
        font-weight:500;
        line-height:20px;
        text-align: center;
        margin-bottom: 32px;
      }
    }
    #checkout-faild-modal {
      .checkout-faild-text {
        font-size:14px;
        font-weight:400;
        color:rgba(54,85,114,1);
        line-height:22px;
      }
    }
    .circular {
      height: 18px;
      width: 18px;
      vertical-align: bottom;
      -webkit-animation: loading-rotate 2s linear infinite;
      animation: loading-rotate 2s linear infinite;
      margin-right: 6px;
    }

    .path {
      -webkit-animation: loading-dash 1.5s ease-in-out infinite;
      animation: loading-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      stroke: #A3B1BF;
      stroke-linecap: round
    }
  }
</style>
